import CheckIcon from "@mui/icons-material/Check";
import LaunchIcon from "@mui/icons-material/Launch";
import { Button, IconButton } from "@mui/material";
import { Link } from "react-router-dom";

// Tab configuration
export const LOG_TABS = {
  TASK_LOGS: "Task Logs",
  ERROR_LOGS: "Error Logs",
  SCRAPER_LOGS: "Scraper Log Streams",
  AUTO4CLIENT_LOGS: "Auto4client Log Streams",
};

// Tab data for rendering
export const TAB_DATA = [
  {
    label: "Task Logs",
    value: "Task Logs",
    tooltip: "Logs from task data stored in MongoDB",
  },
  {
    label: "Scraper Log Streams",
    value: "Scraper Log Streams",
    tooltip: "Log streams from AWS Cloudwatch",
  },
  {
    label: "Auto4client Log Streams",
    value: "Auto4client Log Streams",
    tooltip: "Log streams from AWS Cloudwatch for Auto4client",
  },
  {
    label: "Error Logs",
    value: "Error Logs",
    tooltip: "Logs from MongoDB",
  },
];

// Common column widths (the *_MIN columns flex to fill the table, shrinking to this on small screens)
export const COLUMN_WIDTHS = {
  LINK: 60,
  USER: 150,
  LOG_STREAM_MIN: 250,
  ERROR_MIN: 250,
  SCRAPER_CLASS: 120,
  RESOLVE_BUTTON: 100,
  ERROR_COUNT: 100,
};

// Common cell renderers
export const createLinkCell = (logStreamName) => (
  <IconButton size="small">
    <Link to={`/logs/${encodeURIComponent(logStreamName)}`}>
      <LaunchIcon fontSize="small" />
    </Link>
  </IconButton>
);

export const createResolveButton = (params, selectedErrorIds, toggleErrorSelection) => (
  <Button size="small">
    <CheckIcon
      style={{ color: selectedErrorIds.includes(params.row.id) ? "yellow" : "white" }}
      onClick={() => toggleErrorSelection(params.row.id)}
    />
  </Button>
);

// Table column configurations
export const TABLE_COLUMNS = {
  taskLogs: [
    {
      field: "link",
      headerName: "Link",
      width: COLUMN_WIDTHS.LINK,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => createLinkCell(params.row["Log Stream Name"]),
    },
    {
      field: "User Name",
      headerName: "User",
      type: "string",
      width: COLUMN_WIDTHS.USER,
    },
    {
      field: "Log Stream Name",
      headerName: "Log Stream Name",
      type: "string",
      flex: 1,
      minWidth: COLUMN_WIDTHS.LOG_STREAM_MIN,
    },
    {
      field: "Error Count",
      headerName: "Errors",
      type: "string",
      width: COLUMN_WIDTHS.ERROR_COUNT,
    },
  ],

  logStreams: [
    {
      field: "link",
      headerName: "Link",
      width: COLUMN_WIDTHS.LINK,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => createLinkCell(params.row.logStreamName),
    },
    {
      field: "logStreamName",
      headerName: "Log Stream Name",
      type: "string",
      flex: 1,
      minWidth: COLUMN_WIDTHS.LOG_STREAM_MIN,
    },
  ],

  errors: (selectedErrorIds, toggleErrorSelection) => [
    {
      field: "link",
      headerName: "Link",
      width: COLUMN_WIDTHS.LINK,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => createLinkCell(params.row["Log Stream Name"]),
    },
    {
      field: "Scraper Class",
      headerName: "Scraper Class",
      type: "string",
      width: COLUMN_WIDTHS.SCRAPER_CLASS,
    },
    {
      field: "Log Stream Name",
      headerName: "Log Stream Name",
      type: "string",
      flex: 3,
      minWidth: COLUMN_WIDTHS.LOG_STREAM_MIN,
    },
    {
      field: "Error",
      headerName: "Error",
      type: "string",
      flex: 2,
      minWidth: COLUMN_WIDTHS.ERROR_MIN,
    },
    {
      field: "Resolve button",
      headerName: "",
      width: COLUMN_WIDTHS.RESOLVE_BUTTON,
      renderCell: (params) => createResolveButton(params, selectedErrorIds, toggleErrorSelection),
    },
  ],
};

// Alert states
export const ALERT_TYPES = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
};

// Default states
export const DEFAULT_STATES = {
  FILTER: "",
  DISPLAY_TAB: LOG_TABS.TASK_LOGS,
};
